import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useT } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

const ROLE_KEY = { co_organizer: "collab.roleCo", registration: "collab.roleReg", observer: "collab.roleObs" };

export default function Invite() {
  const { token } = useParams();
  const nav = useNavigate();
  const t = useT();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/invites/${token}`).then(({ data }) => setInfo(data)).catch((e) => setErr(formatApiError(e.response?.data?.detail)));
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/invites/${token}/accept`);
      toast.success(t("invite.accepted"));
      nav(`/events/${data.event_id}`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-card border border-border rounded-lg p-7 space-y-5" data-testid="invite-card">
        <div className="flex items-center gap-2 font-heading font-extrabold text-xl text-foreground"><Logo size={24} className="text-brand-yellow" /> <span>KIHAP</span></div>
        <h1 className="text-2xl font-bold">{t("invite.title")}</h1>
        {err && <p className="text-sm text-hong" data-testid="invite-error">{err}</p>}
        {info && (
          <>
            <p className="text-sm text-muted-foreground">
              <span className="text-foreground font-semibold">{info.event_name}</span> — {t(ROLE_KEY[info.role] || "collab.roleObs")}
            </p>
            {!info.email_match ? (
              <p className="text-sm text-hong" data-testid="invite-wrong-email">{t("invite.wrongEmail")}</p>
            ) : (
              <Button onClick={accept} disabled={busy} className="w-full font-bold" data-testid="invite-accept-btn">{busy ? "…" : t("invite.accept")}</Button>
            )}
          </>
        )}
        <button onClick={() => nav("/dashboard")} className="text-sm text-muted-foreground hover:text-foreground underline" data-testid="invite-home">{t("admin.back")}</button>
      </div>
    </div>
  );
}
